// import { Object3D, PMREMGenerator, RoomEnvironment, use } from '@anov/3d-core'
// import { DynamicWeatherSystem } from './DynamicWeatherSystem'
// import { HDRSky } from './hdr'

// export type Mode = 'sky' | 'hdr'
// export interface WeatherSystemCoreInterface {
//   /**
//    * 时间
//    */
//   time: string

//   /**
//    * 天气
//    */
//   weather: string

//   setTime(time: string): void

//   setWeather(weather: string): void
//   /**
//    * 设置天空模式 默认sky
//    * @param mode 天空模式 sky: 动态, hdr: 静态
//    * @param hdrPath  hdr 路径
//    */
//   setMode(mode: Mode, hdrPath?: string): void
//   /**
//    * 设置hdr
//    * @param hdrPath hdr 路径
//    */
//   setHDR(hdrPath: string): void
// }

// export type WeatherSystemInterface = WeatherSystemCoreInterface & Object3D

// export interface Options {
//   mode: Mode
//   hdrPath?: string
// }

// export class WeatherSystem extends Object3D implements WeatherSystemInterface {
//   private _mode: Mode = 'sky'
//   private _hdrPath = ''
//   private _dynamicWeatherSystem: DynamicWeatherSystem
//   private _hdrSky: any
//   private _currentSky: any

//   constructor(options: Options = { mode: 'sky' }) {
//     super()
//     this._mode = options.mode
//     if (options.mode === 'hdr' && options?.hdrPath) {
//       this._hdrPath = options.hdrPath
//       this._hdrSky = new HDRSky(options)
//       this._currentSky = this._hdrSky
//       this.add(this._hdrSky)
//     }
//     else {
//       this._dynamicWeatherSystem = new DynamicWeatherSystem()
//       this.add(this._dynamicWeatherSystem)
//       this._currentSky = this._dynamicWeatherSystem
//     }
//   }

//   public get weather() {
//     if (this._dynamicWeatherSystem)
//       return this._dynamicWeatherSystem.weather
//     else
//       console.warn('mode is hdr')
//       // this._dynamicWeatherSystem = new DynamicWeatherSystem()
//       // return this._dynamicWeatherSystem.weather
//   }

//   public get time() {
//     if (this._dynamicWeatherSystem)
//       return this._dynamicWeatherSystem.time
//     else
//       console.warn('mode is hdr')
//       // this._dynamicWeatherSystem = new DynamicWeatherSystem()
//       // return this._dynamicWeatherSystem.time
//   }

//   public setTime(time: string) {
//     if (this._dynamicWeatherSystem)
//       this._dynamicWeatherSystem.setTime(time)
//     else
//       console.warn('mode is hdr')
//       // this._dynamicWeatherSystem = new DynamicWeatherSystem()
//       // this._dynamicWeatherSystem.setTime(time)
//   }

//   public setWeather(weather: string) {
//     if (this._dynamicWeatherSystem)
//       this._dynamicWeatherSystem.setWeather(weather)
//     else
//       console.warn('mode is hdr')
//       // this._dynamicWeatherSystem = new DynamicWeatherSystem()
//       // this._dynamicWeatherSystem.setWeather(weather)
//   }

//   public setMode(mode: Mode) {
//     if (this._mode === mode)
//       return
//     const scene = use.useScene().scene
//     this._mode = mode
//     if (mode === 'hdr') {
//       this._dynamicWeatherSystem.visible = false
//       if (!this._hdrSky) {
//         this._hdrSky = new HDRSky({ mode })
//         this.add(this._hdrSky)
//       }
//     }
//     else {
//       const { renderer } = use.useScene()
//       const pmremGenerator = new PMREMGenerator(renderer)
//       pmremGenerator.compileEquirectangularShader()
//       scene.environment = pmremGenerator.fromScene(new RoomEnvironment()).texture
//       this._dynamicWeatherSystem.visible = true
//       scene.background = null
//     }
//   }

//   public async setHDR(hdrPath: string) {
//     if (!this._hdrSky)
//       this._hdrSky = new HDRSky({ mode: 'hdr' })

//     await this._hdrSky.setHDR(hdrPath)
//   }

//   public setRotate(rotate: number) {
//     if (this._hdrSky)
//       this._hdrSky.setRotate(rotate)
//     else console.warn('mode is hdr')
//   }

//   public setIntensity(intensity: number) {
//     if (this._hdrSky)
//       this._hdrSky.setIntensity(intensity)
//     else console.warn('mode is hdr')
//   }
// }
